import { gql } from '@apollo/client';

export const MarkNotificationAsRead = gql`
  mutation MarkNotificationAsRead($id: Int!) {
    markNotificationAsRead(id: $id) {
      id
      hasBeenRead
    }
  }
`;

export const MarkAllNotificationsAsRead = gql`
  mutation MarkAllNotificationsAsRead {
    markAllNotificationsAsRead {
      status
    }
  }
`;

export const DeleteNotification = gql`
  mutation DeleteNotification($id: Int!) {
    deleteNotification(id: $id) {
      status
    }
  }
`;
